import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import Heading from 'LuxKit/Typography/Heading'
import { getRecommendationsTitle } from './utils/recommendationsTitle'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import styled from 'styled-components'
import { useCalendarRecommendationsView } from '../CalendarRecommendationsViewContext'

const Root = styled.div`
  text-align: center;
`

interface Props {
  duration: number
}

function CalendarPickerRecommendationsHeading({
  duration,
}: Props) {
  const intl = useIntl()
  const { view } = useCalendarRecommendationsView()

  const title = useMemo(() => getRecommendationsTitle({
    checkIn: view?.checkIn,
    monthIndex: view?.monthIndex,
    duration,
    intl,
  }).title, [duration, intl, view?.checkIn, view?.monthIndex])

  return <Root>
    <Heading variant="heading3" align="center">{title}</Heading>
  </Root>
}

export default withOfferPageAndReduxState((state) => ({
  duration: state.duration,
}), CalendarPickerRecommendationsHeading)
